import { render, staticRenderFns } from "./tsCheckHis.vue?vue&type=template&id=9b6f5cdc&scoped=true"
import script from "./tsCheckHis.vue?vue&type=script&lang=js"
export * from "./tsCheckHis.vue?vue&type=script&lang=js"
import style0 from "./tsCheckHis.vue?vue&type=style&index=0&id=9b6f5cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6f5cdc",
  null
  
)

export default component.exports